import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AppShell from "../../components/AppShell";
import { api, formatErr } from "../../lib/api";
import { ONSET, PAIN_TYPE, zoneText } from "../../lib/wellness";
import { ReviewBox } from "../../components/wellness/ReviewBox";

const link = (cid) => `/app/admin/clients/${cid}?tab=bienestar`;

export default function AdminWellness() {
  const [d, setD] = useState(null);
  const [err, setErr] = useState(null);
  const load = () => api.get("/admin/wellness/overview").then((r) => setD(r.data)).catch((e) => setErr(formatErr(e)));
  useEffect(() => { load(); }, []);
  const read = (id) => { setD({ ...d, alerts: d.alerts.filter((a) => a.id !== id) }); api.post(`/admin/wellness/alerts/${id}/read`).catch(load); };
  return (
    <AppShell>
      <div className="qv-page-head" data-testid="admin-wellness">
        <div className="label">Cuestionario diario</div>
        <h1>Bienestar</h1>
        <p className="sub">Avisos de dolor alto y sesiones marcadas para revisión. El historial completo está en la ficha de cada futbolista.</p>
      </div>
      {err && <div className="qv-empty">{err}</div>}
      {d && (
        <>
          <div className="qv-card-app" style={{ padding: 16, marginBottom: 12 }} data-testid="aw-alerts">
            <div style={{ fontWeight: 800, marginBottom: 6 }}>Avisos de dolor ({d.alerts.length})</div>
            {!d.alerts.length && <div style={{ fontSize: 13, color: "#a3a3a3" }}>Sin avisos nuevos.</div>}
            {d.alerts.map((a) => (
              <div key={a.id} style={{ display: "flex", justifyContent: "space-between", gap: 8, flexWrap: "wrap", fontSize: 13, padding: "8px 0", borderTop: "1px solid rgba(255,255,255,0.06)" }} data-testid={`aw-alert-${a.id}`}>
                <span><Link to={link(a.client_id)} style={{ color: "#fff", fontWeight: 700 }}>{a.client_name}</Link> · {a.local_date} · {a.kind?.startsWith("pain_") || !a.kind ? <>dolor <b style={{ color: a.kind === "pain_moderate" ? "#facc15" : "#f87171" }}>{a.pain}/10</b>{a.kind === "pain_moderate" ? " (molestia moderada)" : ""}</> : <b style={{ color: "#facc15" }}>{{ fatigue_persistent: "Fatiga persistente", pain_pattern: "Molestia repetida", wellness_drop: "Bienestar en descenso" }[a.kind] || a.kind}</b>} · {a.message || `${zoneText(a.pain_zones)} · ${PAIN_TYPE[a.pain_type]?.[0] || ""} · ${ONSET[a.pain_onset] || ""}`}</span>
                <button className="qv-btn-ghost" style={{ padding: "4px 8px", fontSize: 11 }} onClick={() => read(a.id)} data-testid={`aw-alert-read-${a.id}`}>Marcar leído</button>
              </div>
            ))}
          </div>
          <div className="qv-card-app" style={{ padding: 16 }} data-testid="aw-review">
            <div style={{ fontWeight: 800, marginBottom: 6 }}>Sesiones para revisar: dolor alto o localizado ({d.review.length})</div>
            {!d.review.length && <div style={{ fontSize: 13, color: "#a3a3a3" }}>No hay sesiones pendientes de revisión.</div>}
            {d.review.map((c) => (
              <div key={c.id} style={{ fontSize: 13, padding: "8px 0", borderTop: "1px solid rgba(255,255,255,0.06)" }} data-testid={`aw-review-${c.id}`}>
                <div><Link to={link(c.client_id)} style={{ color: "#fff", fontWeight: 700 }}>{c.client_name}</Link> · {c.local_date} · dolor <b style={{ color: "#f87171" }}>{c.pain}/10</b> · {zoneText(c.pain_zones)} · {PAIN_TYPE[c.pain_type]?.[0]} · {ONSET[c.pain_onset]}{c.today.session_title ? ` · sesión: ${c.today.session_title}` : ""}</div>
                {c.comment && <div style={{ color: "#a3a3a3" }}>«{c.comment}»</div>}
                <ReviewBox c={c} onDone={load} />
              </div>
            ))}
          </div>
        </>
      )}
    </AppShell>
  );
}
